import { Backdrop, SxProps } from "@mui/material";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

type Props = {
  isLoading: boolean;
  sx?: SxProps;
  spinnerSize?: number;
};

const OverlaySpinner = ({ isLoading, sx, spinnerSize }: Props) => (
  <Backdrop
    id="overlay-spinner"
    open={isLoading}
    sx={{
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      zIndex: 1200,
      ...sx,
    }}
  >
    <LoadingSpinner size={spinnerSize} />
  </Backdrop>
);

export default OverlaySpinner;
